import React, { Component, PropTypes } from 'react';
import FormStyles from './Styles';

const ThemeForm = () => {
    return (
        <div className="ThemeForm Theme-Content">
            <h1>Form</h1>
            <div className="subpages-main-content">
                <div className="col-xs-12">
                    <div className="spark-panel spark-mar-t-1 spark-panel-buttons row">
                        <div className="spark-panel__content col-xs-12">
                            <FormStyles
                                id="theme-form-heading"
                                tagNameName="Form"
                                tagName="input"
                                sampleText="First Name"
                                sampleText2="Last Name"
                            />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ThemeForm.propTypes = {
    children: PropTypes.element
};

export default ThemeForm;



// WEBPACK FOOTER //
// ./src/components/pages/theme/form/index.js